module.exports = __webpack_public_path__ + "static/media/Spotify-new-logo.a669fa47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/spotify/Spotify-new-logo.jpg
// module id = 146
// module chunks = 0